<template>
	<div class="product-list">
		<div style="margin-bottom:20px">
			<el-radio-group v-model="formInline.status" @change="btnMenu">
				<el-radio-button label="">全部</el-radio-button>
				<el-radio-button label="0">待审核</el-radio-button>
				<el-radio-button label="1">审核成功</el-radio-button>
				<el-radio-button label="2">驳回</el-radio-button>
			</el-radio-group>
		</div>
		<!--内容-->
		<div class="product-content">
			<div class="table-wrap">
				<el-table size="small" :data="tableData" border style="width: 100%">
					<!-- v-loading="loading" -->
					<el-table-column prop="name" align="center" label="技师姓名" width="150px">
					</el-table-column>
					<el-table-column prop="supplierName" align="center" label="技师来源" width="150px">
					</el-table-column>
					<el-table-column prop="sex" align="center" label="性别">
						<template slot-scope="scope">
							<span v-if="scope.row.sex == 1">男</span>
							<span v-if="scope.row.sex == 0">女</span>
						</template>
					</el-table-column>
					<el-table-column prop="age" align="center" label="年龄"></el-table-column>
					<el-table-column prop="mobile" align="center" label="手机号码"></el-table-column>
					<el-table-column prop="intentionCity" align="center" label="意向城市"></el-table-column>
					<el-table-column label="技师图片" align="center">
						<template slot-scope="scope" v-if="scope.row.imageList">
							<div style="display: flex;width: 100%;">
								<el-image v-for="(item, index) in scope.row.imageList" :key='index'
									style="width:60px;height:60px" :src="item" fit="cover"
									:preview-src-list="[item]"></el-image>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="商户审核状态" align="center">
						<template slot-scope="scope">
							<span style="color: cadetblue" v-if="scope.row.supplierStatus == 0">待审核</span>
							<span style="color: green" v-else-if="scope.row.supplierStatus == 1">审核通过</span>
							<span style="color: red" v-else-if="scope.row.supplierStatus == 2">审核拒绝</span>
						</template>
					</el-table-column>
					<el-table-column label="审核状态" align="center">
						<template slot-scope="scope">
							<span style="color: cadetblue" v-if="scope.row.status == 0">待审核</span>
							<span style="color: green" v-else-if="scope.row.status == 1">审核通过</span>
							<span style="color: red" v-else-if="scope.row.status == 2">审核拒绝</span>
						</template>
					</el-table-column>
					<el-table-column fixed="right" label="操作" align="center" width="100">
						<template slot-scope="scope">
							<el-button v-if="scope.row.status == 0"
								@click="examine(scope.row.status, scope.row.waiterApplyId)" type="primary"
								size="small">审核</el-button>
							<el-button v-else :disabled='true' type="primary" size="small">已审核</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagination">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
				:current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
				:total="totalDataNumber"></el-pagination>
		</div>
		<!-- 审核 -->
		<div>
			<el-dialog title="审核" :visible.sync="dialogVisible" width="30%">
				<el-radio v-model="status" :label="1">审核通过</el-radio>
				<el-radio v-model="status" :label="2">审核不通过</el-radio>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="changestatus()">确 定</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import ProcessApi from "@/api/process.js";
	export default {
		components: {
			// Add
		},
		data() {
			return {
				tableData: [],
				open_add: false,
				/*一页多少条*/
				pageSize: 20,
				/*一共多少条数据*/
				totalDataNumber: 0,
				/*当前是第几页*/
				curPage: 1,
				/*横向表单数据模型*/
				formInline: {
					status: ""
				},
				// 审核是否显示
				dialogVisible: false,
				// 审核状态
				status: 0,
				// 技师id
				waiterApplyId: ""
			};
		},
		created() {
			/*获取列表*/
			this.getData();
		},
		methods: {
			// 点击菜单
			btnMenu() {
				this.curPage = 1
				this.getData();
			},
			/*选择第几页*/
			handleCurrentChange(val) {
				let self = this;
				self.loading = true;
				self.curPage = val;
				self.getData();
			},
			/*每页多少条*/
			handleSizeChange(val) {
				this.pageSize = val;
				this.getData();
			},
			// 获取数据
			getData() {
				let self = this;
				let Params = self.formInline;
				Params.pageIndex = self.curPage;
				Params.pageSize = self.pageSize;
				ProcessApi.technicianEntry(Params, true)
					.then(data => {
						self.tableData = data.data.data;
						console.log(self.tableData);
						self.totalDataNumber = data.data.total;
					})
					.catch(err => {
						console.log(err);
					});
			},
			// 审核
			examine(e, options) {
				this.dialogVisible = true;
				this.waiter_apply_id = options;
			},
			// 提交信息
			changestatus() {
				this.dialogVisible = false;
				console.log(this.status);
				let waiter_apply_id = this.waiter_apply_id;
				if (this.status == "1") {
					ProcessApi.adopt({
							waiter_apply_id
						}, true)
						.then(data => {
							console.log(data);
							this.getData();
						})
						.catch(err => {
							console.log(err);
						});
				}
				if (this.status == "2") {
					ProcessApi.refuse({
							waiter_apply_id
						}, true)
						.then(data => {
							console.log(data);
							this.getData();
						})
						.catch(err => {
							console.log(err);
						});
				}
			}
		}
	};
</script>

<style scoped>
	.fl {
		display: felx;
		align-items: center;
		justify-content: space-between;
	}
</style>


// WEBPACK FOOTER //
// src/views/technician/process/examine/index.vue